import {useSessionStorage} from '../hooks/useSessionStorage'
import { useNavigate } from "react-router-dom";
import { useEffect } from 'react';
import LayoutEditor from '../layout/LayoutEditor'
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';


export default function AboutPage()
{
    return <>
    <link rel="stylesheet" href="/assets/vs2015.css"/>
    <Container maxWidth="md">
    <Typography
            variant="h4"
            color="text.header" sx={{marginTop:2}}>
            About
          </Typography>
    <Grid container spacing={2}>
    <Grid item md={6} xs={12}>
    
    <p>Formulator .NET aims to provide an Excel like formula engine to use in your own apps. Whilst there are many Calculation and Scripting Engines available, they dont provide the same experience as what users are used to with Excel formulas.</p>
    <p>This library is currently in Beta. Please try it out using the Demo and let us know your feedback using the contact page. We will soon be releasing this to use in your own projects.</p>
    
    </Grid>
    <Grid item md={6} xs={12}>
        <Paper sx={{padding:{sm:2, xs:1}, my:2, mx:{md:0, xs:'auto'}}}>
        <code>
          <Typography sx={{ fontFamily:'source-code-pro, Menlo, Monaco, Consolas, \'Courier New\', monospace', typography: { sm: {fontSize:'1rem'}, xs: {fontSize:'0.9rem'} }}} >
            <span className="hljs-keyword">var</span> formulator = <span className="hljs-keyword">new</span> Formulator();
            formulator.Variable(<span className="hljs-string">"foo"</span>, <span className="hljs-string">"bar"</span>);<br/>
            <span className="hljs-keyword">var</span> result = formulator.Evaluate(<span className="hljs-string">@"String.PadLeft( String.Trim(foo), 6, ""-"")"</span>);<br/>
            <span className="hljs-comment">//result: ---bar</span><br/>
            </Typography>
        </code>
        </Paper>
    </Grid>
    </Grid>

    
    
    
    </Container>
    </>
}